import { bulkDeleteHouseConsignmentsV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function bulkDeleteHouseConsignments(ids: number[]): Promise<void> {
  await bulkDeleteHouseConsignmentsV3({ houseConsignmentIds: ids })
}
